import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useT } from "./i18n";
import "./styles/chat_selection.css";

function ChatSelection() {
  const navigate = useNavigate();
  const t = useT();

  const [dropdowns, setDropdowns] = useState({
    agent1: false,
    agent2: false,
    agent3: false,
    agent4: false,
  });

  function toggleDropdown(agent) {
    setDropdowns(prev => ({
      ...prev,
      [agent]: !prev[agent],
    }));
  }

  function createPromptTemplate({
    vibrancy = "0",
    conscientiousness = "0",
    civility = "0",
    artificiality = "0",
    neuroticism = "0",
  } = {}) {
    return (
      "CONTEXT \n" +
      "Personality Model: \n" +
      "Given is a unique personality profile based on five key dimensions: Vibrancy, Conscientiousness, Civility, Artificiality, and Neuroticism. \n" +
      "Each dimension has a set of associated adjectives: \n" +
      "- Vibrancy is described by the adjectives: enthusiastic, joyful, cheerful, social, adventurous, curious, motivated, passionate, playful, talkative, welcoming, optimistic, active, inquisitive, communicative, humorous, determined, interested, explorative, caring, engaging, proactive, affectionate, creative, inspiring, brave, generous, responsive, suggestive, sensitive, open-minded, interactive, casual, verbal. \n" +
      "- Conscientiousness is described by the adjectives: logical, precise, efficient, organized, informative, smart, knowledgeable, intellectual, functional, self-disciplined, concise, thorough, objective, insightful, wise, formal, useful, stable, responsible, deep, articulate, consistent, diplomatic, helpful, mindful, considerate, not contradictory, complex, direct, philosophical, critical, understandable. \n" +
      "- Civility is described by the adjectives: not offensive, not rude, not arrogant, respectful, polite, accepting, not harsh, not confrontational, humble, not irritable, tolerant, not patronizing, gentle, not stubborn, courteous, calm, agreeable, not angry, understanding, cooperative, careful, friendly, assertive, patient, confident, submissive, neutral, not narrow-minded, supportive, easygoing, not self-centered, not overbearing, reserved. \n" +
      "- Artificiality is described by the adjectives: computerized, boring, emotionless, fake, robotic, annoying, not human-like, predictable, shallow, repetitive, vague, haphazard, dysfunctional, cold, confusing, creepy, simple, not realistic, inhibited, old-fashioned, dependent, self-aware. \n" +
      "- Neuroticism is described by the adjectives: depressed, pessimistic, negative, fearful, complaining, frustrated, agitated, lonely, upset, shy, helpless, worried, moody, confused, scatterbrained, lost, preoccupied, absentminded, pensive, careless, nostalgic, defensive, deceitful, romantic. \n" +
      "Personality Scale: \n" +
      "Each dimension has a certain intensity level from -2 to +2. \n" +
      "Personality Profile: \n" +
      "- Vibrancy: Level " + vibrancy + "\n" +
      "- Conscientiousness: Level " + conscientiousness + "\n" +
      "- Civility: Level " + civility + "\n" +
      "- Artificiality: Level " + artificiality + "\n" +
      "- Neuroticism: Level " + neuroticism + "\n" +
      t.promptTask
    );
  }

  const [agent1Prompt, setAgent1Prompt] = useState(createPromptTemplate({ vibrancy: "+2" }));
  const [agent2Prompt, setAgent2Prompt] = useState(createPromptTemplate({ conscientiousness: "+2" }));
  const [agent3Prompt, setAgent3Prompt] = useState(createPromptTemplate({ civility: "+2" }));
  const [agent4Prompt, setAgent4Prompt] = useState(createPromptTemplate({ artificiality: "+2" }));

  const goToChat = (agentType, prompt) => {
    navigate("/chat", {
      state: { agentType, initialPrompt: prompt },
    });
  };

  return (
    <div className="page-container">
      <div>
        <h1 className="title">{t.chatSelection.title}</h1>

        <p className="description">{t.chatSelection.description}</p>

        <div className="agents-container">

          {/* Agent 1 */}
          <div className="agent-card">
            <div className="agent-buttons">
              <button
                className="button"
                onClick={() => goToChat("vibrancy", agent1Prompt)}
              >
                Avernano
              </button>
              <a
                className="button"
                href="https://hefr.eu.qualtrics.com/jfe/form/SV_3IuIC6SKw6S4fwq?Q_Language=EN-GB"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t.common.fillQuestionnaire}
              </a>
            </div>

            {dropdowns.agent1 && (
              <div className="dropdown">
                <label><strong>{t.common.initialPrompt}</strong></label>
                <textarea
                  className="textarea"
                  value={agent1Prompt}
                  onChange={(e) => setAgent1Prompt(e.target.value)}
                />
              </div>
            )}
          </div>

          {/* Agent 2 */}
          <div className="agent-card">
            <div className="agent-buttons">
              <button
                className="button"
                onClick={() => goToChat("conscientiousness", agent2Prompt)}
              >
                Idomedes
              </button>

              <a
                className="button"
                href="https://hefr.eu.qualtrics.com/jfe/form/SV_0ON3ClkFC12shSK?Q_Language=EN-GB"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t.common.fillQuestionnaire}
              </a>
            </div>

            {dropdowns.agent2 && (
              <div className="dropdown">
                <label><strong>{t.common.initialPrompt}</strong></label>
                <textarea
                  className="textarea"
                  value={agent2Prompt}
                  onChange={(e) => setAgent2Prompt(e.target.value)}
                />
              </div>
            )}
          </div>

          {/* Agent 3 */}
          <div className="agent-card">
            <div className="agent-buttons">
              <button
                className="button"
                onClick={() => goToChat("civility", agent3Prompt)}
              >
                Anatanos
              </button>

              <a
                className="button"
                href="https://hefr.eu.qualtrics.com/jfe/form/SV_5z2Kzia6AsKvTme?Q_Language=EN-GB"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t.common.fillQuestionnaire}
              </a>
            </div>

            {dropdowns.agent3 && (
              <div className="dropdown">
                <label><strong>{t.common.initialPrompt}</strong></label>
                <textarea
                  className="textarea"
                  value={agent3Prompt}
                  onChange={(e) => setAgent3Prompt(e.target.value)}
                />
              </div>
            )}
          </div>

          {/* Agent 4 */}
          <div className="agent-card">
            <div className="agent-buttons">
              <button
                className="button"
                onClick={() => goToChat("artificiality", agent4Prompt)}
              >
                Kalaris
              </button>

              <a
                className="button"
                href="https://hefr.eu.qualtrics.com/jfe/form/SV_0k2NKJwscIUJhjM?Q_Language=EN-GB"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t.common.fillQuestionnaire}
              </a>
            </div>

            {dropdowns.agent4 && (
              <div className="dropdown">
                <label><strong>{t.common.initialPrompt}</strong></label>
                <textarea
                  className="textarea"
                  value={agent4Prompt}
                  onChange={(e) => setAgent4Prompt(e.target.value)}
                />
              </div>
            )}
          </div>

        </div>

        <div className="bottom-container">
          <button className="button" onClick={() => navigate("/etude")}>
            {t.common.previous}
          </button>

          <button className="button" onClick={() => navigate("/questionnaire")}>
            {t.common.next}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ChatSelection;
